import './Notification.scss';
import { NotificationProps } from '@customTypes/PropTypes';

const Notification = ({ classOverride = '', children } : NotificationProps) : JSX.Element => (
    <div className={`notification-component ${classOverride}`}>
        {children}
    </div>
);

export default Notification;
